import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { getHttpInstance, getApiConfig } from './useApi';
export function useContent() {
    const api = useApi();
    const state = useAppState();
    function getCmsArticles(tags = null, onSuccess = null) {
        api.GET("/CMS/Articles?tags=" + (tags ?? ''), (result) => {
            state.articles = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getCmsArticleByKey(key, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/CMS/Articles/SearchRequests?key=" + key, null)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data.length > 0 ? response.data[0].article : null);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => getCmsArticleByKey(key, onSuccess));
            }
        });
    }
    function getCmsArticle(id, onSuccess = null) {
        if (id.split('-').length != 5) {
            return getCmsArticleByKey(id, (result) => {
                state.article = result;
                if (onSuccess)
                    onSuccess();
            });
        }
        else {
            api.GET("/CMS/Articles/" + id, (result) => {
                state.article = result;
                if (onSuccess)
                    onSuccess();
            }, true);
        }
    }
    function getWalkthrough(key, onSuccess = null) {
        api.GET("/CMS/Walkthroughs/Keys/" + key, (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getPersonalNews(onSuccess = null, allowRetry = true) {
        getHttpInstance().get(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/News")
            .then((result) => {
            if (onSuccess)
                onSuccess(result.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => getPersonalNews(onSuccess, true));
            }
            else if (result.response && result.response.status == 503) {
                if (allowRetry) {
                    if (onSuccess)
                        onSuccess("I'm still working on that 💭💭 It Shouldn't be too much longer. Hang tight!", true);
                    setTimeout(() => { getPersonalNews(onSuccess, false); }, 15000);
                }
                else {
                    if (onSuccess)
                        onSuccess("Sorry, something went wrong while generating your news.  That's embarrasing... 😬 Please try again later.");
                }
            }
            else if (result.code == 'ERR_NETWORK') {
                if (allowRetry) {
                    if (onSuccess)
                        onSuccess("I'm still working on that 💭💭 It Shouldn't be too much longer. Hang tight!", true);
                    setTimeout(() => { getPersonalNews(onSuccess, false); }, 15000);
                }
                else {
                    if (onSuccess)
                        onSuccess("Sorry, something went wrong while generating your news.  That's embarrasing... 😬 Please try again later.");
                }
            }
        });
    }
    function getPlans(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Plans", (result) => {
            state.plans = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getPlan(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/" + id, (result) => {
            state.plan = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getPlanSection(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/" + id, (result) => {
            state.planSection = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function getPlanTask(id, onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/Tasks/" + id, (result) => {
            state.planTask = result;
            if (onSuccess)
                onSuccess();
        }, true);
    }
    function setPlanTaskCompleted(taskId, completed, onSuccess = null) {
        const request = { "completed": completed };
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Plans/Sections/Tasks/" + taskId + "/SetStatusRequests", request)
            .then((response) => {
            clearPlan();
            if (onSuccess)
                onSuccess(response);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => setPlanTaskCompleted(taskId, completed, onSuccess));
            }
        });
    }
    function clearPlan() {
        console.log('Clearing plans cache');
        Object.keys(localStorage).forEach(key => {
            if (key.includes('/Plans')) {
                localStorage.removeItem(key);
            }
        });
    }
    function getBenefits(onSuccess = null, benefitsRequest) {
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Benefits", {
            relationshipStatus: benefitsRequest.relationshipStatus,
            dob: benefitsRequest.dob,
            childrenNum: benefitsRequest.childrenNum,
            housingType: benefitsRequest.housingType,
            postcode: benefitsRequest.postcode,
            monthlyIncomeAmount: benefitsRequest.monthlyIncomeAmount,
            monthlyBenefitsAmount: benefitsRequest.monthlyBenefitsAmount
        })
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => getBenefits(onSuccess, benefitsRequest));
            }
        });
    }
    function getLatestFinancialFitness(onSuccess = null) {
        getFinancialFitness((l) => {
            state.financialFitness = l[0];
            if (onSuccess)
                onSuccess(l[0]);
        });
    }
    function getFinancialFitness(onSuccess = null, clearCache = false) {
        const config = getApiConfig();
        const uri = config.api + (config.useCachedEndpoints ? '/Cached' : '') + "/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness";
        if (clearCache) {
            localStorage.removeItem(uri);
            return;
        }
        api.GET(uri, (result) => {
            state.financialFitnessHistory = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function generateFinancialFitness(onSuccess = null, clearCache = false) {
        const uri = getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness/GenerateRequests";
        if (clearCache) {
            localStorage.removeItem(uri);
            return;
        }
        getHttpInstance().post(uri, null)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => generateFinancialFitness(onSuccess));
            }
        });
    }
    function clearFinancialFitness() {
        const config = getApiConfig();
        localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/FinancialFitness');
    }
    function getAiopSection(sectionName, onSuccess = null) {
        const origHeaders = getHttpInstance().defaults.headers.common;
        getHttpInstance().defaults.headers.common = null;
        getHttpInstance().get(state.aiopSectionsS3Bucket + sectionName)
            .then((result) => {
            state.sectionJson = result.data.sections;
            if (onSuccess)
                onSuccess();
        })
            .catch(() => {
            import(/* webpackExclude: /__tests__/ */ '../components/' + sectionName)
                .then((module) => {
                state.sectionJson = module.default.sections;
                console.log(state.sectionJson, 'sectionJson');
                if (onSuccess)
                    onSuccess();
            })
                .catch((error) => {
                console.error('Failed to load both S3 and local section file:', error);
                if (onSuccess)
                    onSuccess();
            });
        });
        getHttpInstance().defaults.headers.common = origHeaders;
    }
    function getProduct(productId, onSuccess = null) {
        api.GET("/Products/" + productId, (result) => {
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function getFaqs(name = null, onSuccess = null) {
        api.GET("/Faq/Name/" + (name ? name : ""), (result) => {
            state.faqs = result;
            if (onSuccess)
                onSuccess(result);
        }, true);
    }
    function createFaq(faqData, onSuccess = null) {
        getHttpInstance().post(getApiConfig().api + '/Faq', faqData)
            .then((response) => {
            if (onSuccess)
                onSuccess(response.data);
        });
    }
    function getSuggestedAssets(onSuccess = null) {
        api.GET("/Customers/00000000-0000-0000-0000-000000000000/SuggestedAssets", (result) => {
            if (onSuccess)
                onSuccess(Array.isArray(result) ? result : []);
        }, /* useCache*/ true, /* refreshCache */ false, /* ttlMins */ 3, /* retrying */ false, /* staleWhileRevalidate */ true);
    }
    return {
        getCmsArticles,
        getCmsArticleByKey,
        getCmsArticle,
        getWalkthrough,
        getPersonalNews,
        getPlans,
        getPlan,
        getPlanSection,
        getPlanTask,
        setPlanTaskCompleted,
        clearPlan,
        getBenefits,
        getLatestFinancialFitness,
        getFinancialFitness,
        generateFinancialFitness,
        clearFinancialFitness,
        getAiopSection,
        getProduct,
        getFaqs,
        createFaq,
        getSuggestedAssets,
    };
}
